import {
    SEE_COMMENTS, ADD_COMMENT, SEE_COMMENTS_MULTI, ADD_COMMENT_MULTI, IS_LOADING_COMMENTS, IS_LOADING_COMMENTS_MULTI, DELETE_COMMENTS, DELETE_COMMENTS_MULTI, SEE_REPLY_COMMENTS, ADD_REPLY_COMMENT,
    IS_LOADING_REPLY_COMMENTS, DELETE_REPLY_COMMENTS, IS_LOADING_LIKE_COMMENTARY, ADD_LIKE_COMMENTARY, ADD_LIKE_REPLY_COMMENTARY
} from '../actions/types'

const initialState = {
    comments: [],
    replyComments: [],
    isLoadingComments: true,
    isLoadingReplyComments: true,
    isLoadingCountReplyComments: false,
    commentsMulti: [],
    isLoadingCommentsMulti: true,

}

export default function (state = initialState, action) {

    switch (action.type) { //que me llega la cadena type para el switch y el payload en este caso 
        case SEE_COMMENTS:
            return { ...state, comments: action.payload, isLoadingComments: false }
        case "ADD_COMMENT_FROM_ANOTHER":
            var comments = state.comments
           
            //action.payload.comments.picture=localStorage().getItem("picturProfile")
            if (comments.find (comment => comment._id === action.payload._id) === undefined ) {
                comments.push({
                    ...action.payload
                })
            }

            console.log()
            return { ...state, comments: comments, isLoadingComments: false }
        case ADD_COMMENT:
            console.log()
            var comments = state.comments
            //action.payload.comments.picture=localStorage().getItem("picturProfile")
            comments.push({
                ...action.payload,


            })
            console.log()
            return { ...state, comments: comments, isLoadingComments: false }
        case IS_LOADING_COMMENTS:
            return { ...state, isLoadingComments: true }
        case DELETE_COMMENTS:
            var comments = state.comments.filter(item => item._id !== action.payload)
            return { ...state, isLoadingComments: false, comments: comments }
        case IS_LOADING_LIKE_COMMENTARY:
            return { ...state, isLoadingLikePost: true }
        case ADD_LIKE_COMMENTARY:
            var currentComments = state.comments
            currentComments.map((comment) => {
                if (comment._id === action.payload.contentID) {
                    comment.reactions = action.payload.value
                }
            })
            return { ...state, comments: currentComments, isLoadingLikePost: false }
        case ADD_LIKE_REPLY_COMMENTARY:
            var currentComments = state.replyComments
            currentComments.map((comment) => {
                if (comment._id === action.payload.contentID) {
                    comment.reactions = action.payload.value
                }
            })
            return { ...state, replyComments: currentComments, isLoadingLikePost: false }
        case SEE_COMMENTS_MULTI:
            return { ...state, commentsMulti: action.payload, isLoadingCommentsMulti: false }
        case ADD_COMMENT_MULTI:
            var comments = state.commentsMulti
            comments.push(action.payload)
            console.log()
            return { ...state, commentsMulti: comments, isLoadingCommentsMulti: false }
        case IS_LOADING_COMMENTS_MULTI:
            return { ...state, isLoadingCommentsMulti: true }
        case DELETE_COMMENTS_MULTI:
            var comments = state.commentsMulti.filter(item => item._id !== action.payload)
            return { ...state, isLoadingCommentsMulti: false, commentsMulti: comments }
        case SEE_REPLY_COMMENTS:
            console.log()
            return { ...state, replyComments: action.payload.commentResponsesIDS, isLoadingReplyComments: false, isLoadingCountReplyComments: false }
        case ADD_REPLY_COMMENT:
            console.log()
            var replyComments = state.replyComments
            replyComments.push({
                ...action.payload,


            })

            var idComment = replyComments[0].commentID
            var currentComments = state.comments
            currentComments.map((comment) => {
                if (comment._id === idComment) {
                    comment.responses += 1
                }
            })
            return { ...state, replyComments: replyComments, isLoadingReplyComments: false, isLoadingCountReplyComments: false }
        case IS_LOADING_REPLY_COMMENTS:
            return { ...state, isLoadingReplyComments: true, isLoadingCountReplyComments: true }
        //case IS_LOADING_COUNT_REPLY_COMMENTS:
        // return { ...state, isLoadingCountReplyComments:true}
        case DELETE_REPLY_COMMENTS:
            var replyComments = state.replyComments.filter(item => item._id !== action.payload)
            var idComment = replyComments[0].commentID
            var currentComments = state.comments
            currentComments.map((comment) => {
                if (comment._id === idComment) {
                    comment.responses -= 1
                }
            })
            return { ...state, isLoadingReplyComments: false, isLoadingCountReplyComments: false, replyComments: replyComments }
        default:
            return state
    }
}